import { COLOR_BLUE_900 } from '@alltrails/denali/tokens';
import { createCircleMarker } from './svgMarkerComponents';

const userCustomMapPinClusterHoveredSvg = createCircleMarker({
  imageName: 'user-custom-map-pin-cluster-hovered',
  innerDiameter: 24,
  innerFill: COLOR_BLUE_900
});

export default userCustomMapPinClusterHoveredSvg;
